<template>
  <div id="baseFormDevice">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="12" md="12" lg="12" xl="10">
        <CRow>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data" ref="connectStatusSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data" ref="activeStatusSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseInput :options="codeInput.options" :data="codeInput.data" />
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseInput :options="descriptionInput.options" :data="descriptionInput.data" />
          </CCol>
        </CRow>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="2">
        <CRow>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                  class="btn-action-primary" @click="submitRefresh()">
                  <i class="fa fa-refresh"></i>&nbsp;Tải lại
                </CButton>
                <!--                <CButton-->
                <!--                  style="float: right;margin-left: 5px;"-->
                <!--                  color="primary"-->
                <!--                  v-c-tooltip.hover="'Thực hiện phát thanh'"-->
                <!--                  class="btn-action-primary"-->
                <!--                  @click="loadDataMainTable(true)">-->
                <!--                  <i class="fa fa-microphone"></i>&nbsp;Phát thanh-->
                <!--                </CButton>-->
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          @change-selectedAll="changeSelectAll($event)" @row-click="rowClickTable($event)" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox ">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.listDeviceSelectedCode"
                  :value="item.id" :id="item.id" />
                <label class="custom-control-label" :class="isValid ? 'input-valid-error' : ''" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #code="{ item }">
            <td>
              <div class="device-code-cell">
                <span :key="'code' + item.id + item.code" v-c-tooltip:hover="item.code" class="description device-code-line">
                  <span class="device-code-value">{{ item.code }}</span>
                  <i v-if="$hasAuthor('ROLE_ADMIN')" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                    @click="copyPhoneNumber(item.code)"></i>
                </span>
                <span v-if="item.type !== undefined && item.type !== null"
                  :key="'type' + item.id + item.type" class="badge badge-light device-code-type">
                  {{ item.type === 0 ? 'Truyền thanh cơ sở' : 'Tích hợp tự động' }}
                </span>
              </div>
            </td>
          </template>
          <template #phoneNumber="{ item, index }">
            <td>
              <template v-if="item.networkType === 0">
                <span v-if="item.ipAddress != null && item.ipAddress != ''">
                  {{ item.ipAddress }}
                  <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                    @click="copyPhoneNumber(item.ipAddress)"></i>&nbsp;
                </span>
                <span v-else :key="phoneTooltipKey(item)"
                  v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }"
                  class="badge badge-light">Chưa xác định </span>
              </template>
              <template v-else>
                <span v-if="item.phoneNumber != null && item.phoneNumber != ''">
                  <span :key="phoneTooltipKey(item)"
                    v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }">{{
                      item.phoneNumber
                    }} </span>
                  <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                    @click="copyPhoneNumber(item.phoneNumber)"></i>&nbsp;
                </span>
                <span v-else :key="phoneTooltipKey(item)"
                  v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }"
                  class="badge badge-light">Chưa xác định </span>
                <template>
                  <br />
                  <div id="bars">
                    <div class="bar"
                      :style="item.phoneSignal >= 1 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 2 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 3 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 4 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                  </div>
                  <span style="font-weight: 700;">{{ generatePhoneNetWork(item) }}</span>
                </template>
              </template>
            </td>
          </template>
          <template #volume="{ item }">
            <td class="volume">
              <CDropdown color="p-1" placement="bottom-end" addMenuClasses="dropdown-volume"
                addTogglerClasses="custom-toggle-volume" :caret="false">
                <template #toggler-content>
                  <i class="fa" :class="generateIconVolume(item.volume)"
                    style="cursor: pointer;font-size: 16px!important;"></i>
                  <span class="ml-2">{{ item.volume }}
                  </span>
                </template>
                <CDropdownItem>
                  <range-slider class="slider" min="0" max="100" step="5" v-model="item.volume"
                    @change="changeVolume(item.id, item.volume)">
                  </range-slider>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{ item }">
            <td>
              <template v-if="item.type == 1">
                <span class="badge badge-light" v-if="item.activeStatus == 1"
                  style="display: inline-flex;align-items: center;" :key="'activeStatus' + item.id + item.activeStatus"
                  v-c-tooltip="'Xem nội dung'" @click.prevent="viewSchedulePlaying(item, item.type)">
                  <i class="fa fa-play-circle-o speaker " style="color:green"></i>
                  &nbsp;{{ item.micAvailable == true ? 'Có tín hiệu' : 'Không tín hiệu' }}
                  <span>{{ item.micAvailable == true ? '&nbsp;/&nbsp;' + item.bitrate : '' }}</span>
                </span>
                <span class="badge badge-light" v-if="item.activeStatus == 0"
                  style="display: inline-flex;align-items: center;">
                  <i class="fa fa-stop-circle-o speaker"></i>
                  &nbsp;Không tín hiệu
                </span>
                <br />
              </template>
              <template v-else>
                <span class="badge badge-light" v-if="item.activeStatus == 0 || item.activeStatus == 1"
                  :key="'activeStatus' + item.id + item.activeStatus" v-c-tooltip="'Xem nội dung'"
                  @click.prevent="viewSchedulePlaying(item, item.type)">
                  <i class="fa fa-play-circle-o speaker "
                    :style="item.activeStatus == 0 ? 'color:green' : 'color:#e39f00'"></i>
                  <span v-for="speaker in item.numberSpeakers">
                    <template v-if="item.activeStatus == 1">
                      <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                        :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                        :style="speaker.running ? 'color:#e39f00' : ''"></i>
                    </template>
                    <template v-else="item.activeStatus == 0">
                      <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                        :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                        :style="speaker.running ? 'color:green' : ''"></i>
                    </template>
                  </span>
                </span>
                <span class="badge badge-light" v-if="item.activeStatus == 2" v-c-tooltip.hover="'Không phát sóng'">
                  <i class="fa fa-stop-circle-o speaker"></i>
                  <span v-for="speaker in item.numberSpeakers">
                    <i class="fa fa-volume-off ml-2 speaker" :key="'speaker' + item.id + speaker.id"></i>
                  </span>
                </span>
              </template>
            </td>
          </template>
          <template #connectStatus="{ item }">
            <td>
              <div style="display: inline-flex;width: 100%;height: 100%; align-items: center;">
                <i v-if="$hasAuthor('ROLE_ADMIN')" v-c-tooltip.hover="'Nhiệt độ: ' + `${parseInt(item.temperature)}℃`"
                  :key="item.temperature" style="font-size: 22px;font-weight: 500;"
                  :style="item.temperature < 80 ? 'color:black;' : 'color:red;'" class="mr-2 fa"
                  :class="item.temperature < 80 ? 'fa-thermometer-quarter' : 'fa-thermometer-full'"></i>
                <div class="wattage-group" v-if="item.type == 0">
                  <template v-if="item.wattage === 1">
                    <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;color:#2eb85c"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Bật'"></i>
                  </template>
                  <template v-else-if="item.wattage === 0">
                    <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Tắt'"></i>
                  </template>
                  <template v-else>
                    <i class="mr-2 fa fa-ban" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Không xác định'"></i>
                  </template>
                </div>
                <div class="networkType-group">
                  <template v-if="item.networkType === 1">
                    <i class="mr-2 fa fa-wifi" style="font-size: 22px;font-weight: 500;"
                      :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Mạng không dây'"></i>
                  </template>
                  <template v-else-if="item.networkType === 0">
                    <svg width="25px" height="25px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" class="mr-2"
                      v-c-tooltip.hover="'Mạng có dây'" :key="'networkType' + item.id + item.networkType"
                      style="margin-top: -3px">
                      <g id="Layer_2">
                        <g id="invisible_box" data-name="invisible box">
                          <rect width="24" height="24" fill="none" />
                        </g>
                        <g id="horoscope">
                          <g>
                            <path
                              d="M25.6,25.6,22.2,29,19,25.8l3.4-3.4a2,2,0,0,0-2.8-2.8L16.2,23l-1.3-1.3a1.9,1.9,0,0,0-2.8,0l-3,3a9.8,9.8,0,0,0-3,7,9.1,9.1,0,0,0,1.8,5.6L4.6,40.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0l3.2-3.2a10.1,10.1,0,0,0,5.9,1.9,10.2,10.2,0,0,0,7.1-2.9l3-3a2,2,0,0,0,.6-1.4,1.7,1.7,0,0,0-.6-1.4L25,31.8l3.4-3.4a2,2,0,0,0-2.8-2.8Z" />
                            <path
                              d="M43.4,4.6a1.9,1.9,0,0,0-2.8,0L37.2,8a10,10,0,0,0-13,.9l-3,3a2,2,0,0,0-.6,1.4,1.7,1.7,0,0,0,.6,1.4L32.9,26.4a1.9,1.9,0,0,0,2.8,0l3-2.9a9.9,9.9,0,0,0,2.9-7.1A10.4,10.4,0,0,0,40,10.9l3.4-3.5A1.9,1.9,0,0,0,43.4,4.6Z" />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </template>
                  <template v-else>
                    <i class="mr-2 fa fa-ban" style="font-size: 22px;font-weight: 500;"
                      :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Chưa xác định'"></i>
                  </template>
                </div>
                <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
                <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
              </div>

            </td>
          </template>
          <template #locationName="{ item }">
            <td>
              <span class="badge "
                :class="(item.locationName != null && item.locationName != '') ? 'badge-light' : 'badge-danger'">
                {{ (item.locationName != null && item.locationName != '') ? item.locationName : 'Chưa gán' }}</span>
            </td>
          </template>
        </BaseTable>

      </CCardBody>
    </CCard>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import { DatePicker } from "v-calendar";
import BaseModal from "@/views/base/BaseModal";

export default {
  name: "BaseFormDevice",
  components: {
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  props: {
    loadData: {
      type: Boolean,
      default: true
    },
    reset: Boolean,
    isValid: Boolean
  },
  data() {
    let that = this;
    return {
      loading: { value: false },
      isFirstLoad: true,
      isShowModalChangeVolumeMultipleDevice: false,
      isShowModalUpdateDescription: false,
      volumeChangeMultipleDevice: 50,
      dataDescription: {
        id: null,
        descriptionInput: {
          options: {
            label: "Mô tả thiết bị",
            placeholder: "Mô tả thiết bị",
            maxlength: 2000,
            rows: 5
          },
          data: {
            name: "description",
            model: "",
            updateCallback: function () {
              that.submitUpdateDescription();
            }
          }
        }
      },
      actionData: {
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listDeviceSelectedCode: [],
          type: null,
          deviceIgnoreIds: [],
          checkAll: false,
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả địa chỉ",
          label: 'Mô tả địa chỉ'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      // isDevice: {
      //   data: {
      //     name: 'isDevice',
      //     model: 2
      //   }
      // },
      locationStatusSelect: {
        data: {
          name: "isDevice",
          model: "0",
        }
      },
      typeDeviceSelect: {
        data: {
          name: "type",
          model: "0",
        }
      },
      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "1", value: "Kết nối" },
            { key: "0", value: "Mất kết nối" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            { key: "-1", value: "Tất cả trạng thái" },
            { key: "0", value: "Đang phát sóng" },
            { key: "1", value: "Tạm dừng phát sóng" },
            { key: "2", value: "Không phát sóng" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },

      mainTable: {
        options: {
          fields: [
            { key: "checkbox", label: " ", sorter: false, filter: false },
            { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
            { key: "code", label: "Mã thiết bị" },
            { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:10%" },
            { key: "activeStatus", label: "Trạng thái hoạt động" },
            { key: "connectStatus", label: "Trạng thái kết nối" },
            { key: "volume", label: "Âm lượng", _style: "width:8%;" },
            { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
            { key: "locationName", label: "Địa bàn" },
          ],
          slots: ["checkbox", "index", "code", "volume", "phoneNumber", "activeStatus", "phoneNumber", "temperature", "connectStatus", "updateDate", "locationName", "action"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          pageSize: 20,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm...', external: false, lazy: true},
          lazyLoad: this.$hasAuthor('ROLE_WARD') || this.$hasAuthor('ROLE_VILLAGE') ? true : false,
          isSelectedAll: true,
          selectedAll: false,
        },
        dataSource: {
          url: "/devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            if (that.actionData.model.selectedAll) {
              that.$emit("dataSearch", that.$helper.setupDataSubmit(that.$data));
            }
            dataResponse.data.dataContent.content.map(each => {
              if (that.actionData.model.listDeviceSelectedCode.includes(each.id)) {
                each._classes = 'active';
              } else {
                if (that.actionData.model.checkAll && !that.actionData.model.deviceIgnoreIds.includes(each.id)) {
                  that.actionData.model.listDeviceSelectedCode.push(each.id)
                  each._classes = 'active';
                }
              }
            })
            return dataResponse.data;
          }
        }
      },
    }
  },
  methods: {
    submitRefresh() {
      this.actionData.model.listDeviceSelectedCode = [];
      this.actionData.model.selectedAll = false;
      this.actionData.model.checkAll = false;
      this.actionData.model.deviceIgnoreIds = [];
      this.mainTable.options.selectedAll = false;
      this.loadDataMainTable(true);
    },
    generatePhoneNetWork(item) {
      var res = '';
      var phoneNetwork = item.phoneNetworkMode.toString();
      if (item && phoneNetwork) {
        // var network = phoneNetwork.split(".");
        switch (phoneNetwork) {
          case "0": {
            res = 'NO SERVICE';
            break;
          }
          case "1": {
            res = 'GSM';
            break;
          }
          case "2": {
            res = 'G';
            break;
          }
          case "3": {
            res = 'E';
            break;
          }
          case "4": {
            res = '3G';
            break;
          }
          case "5": {
            res = '3G+';
            break;
          }
          case "6": {
            res = 'H';
            break;
          }
          case "7": {
            res = 'H+';
            break;
          }
          case "8": {
            res = 'LTE';
            break;
          }
          // case "9": {
          //   break;
          // }
          // case "10": {
          //   break;
          // }
          // case "11": {
          //   break;
          // }
          // case "12": {
          //   break;
          // }
          // case "13": {
          //   break;
          // }
          // case "14": {
          //   break;
          // }
          // case "15": {
          //   break;
          // }
          // case "16": {
          //   break;
          // }
          // case "23": {
          //   break;
          // }
          // case "24": {
          //   break;
          // }
        }
      }
      return res;
    },
    copyPhoneNumber(phoneNumber) {
      navigator.clipboard.writeText(phoneNumber);
      this.showSuccessMsg({ message: "Copy thành công" });
    },
    phoneTooltipKey(item) {
      return [
        "phone",
        item.id,
        item.phoneNumber,
        item.phoneImei,
        item.phoneCcId,
        item.networkProvider,
        item.ipAddress
      ].join("-");
    },
    getInformationPhone(item) {
      let response = `<div class="text-left"><div><b>Nhà mạng:</b> ${item.networkProvider}</div>
                       <div><b>IMEI:</b> ${item.phoneImei}</div>`;
      // if (item.phoneDataCapacity != null) {
      //   response += `<div><b>Dung lượng:</b> ${item.phoneDataCapacity}</div>`;
      // }
      // if (item.phoneDateActive) {
      //   response += `<div><b>Data có hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateActive)}</div>`;
      // }

      // if (item.phoneDateExpired) {
      //   response += `<div><b>Data hết hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateExpired)}</div>`;
      // }
      // if (item.dateWarranty) {
      //   response += ` <div> <b>Thời hạn bảo hành:</b> ${this.$helper.formatDateDDMMYYYY(moment(item.dateWarranty).add(1, 'y'))} </div>`;
      // }
      if (item.phoneCcId) {
        response += ` <div> <b>ICCID:</b> ${item.phoneCcId} </div>`;
      }
      response += '</div>';
      return response;
    },
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.items.map(each => delete each._classes);
      this.$refs.mainTable.loadData(isUpdateFilter, isLoading);
    },
    changeSelectAll: function (value) {
      this.actionData.model.selectedAll = value;
      this.actionData.model.checkAll = value;
      if (this.actionData.model.selectedAll) {
        this.actionData.model.deviceIgnoreIds = [];
        this.actionData.model.listDeviceSelectedCode = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listDeviceSelectedCode.push(each.id);
        });
      } else {
        this.actionData.model.listDeviceSelectedCode = [];
        this.actionData.model.deviceIgnoreIds = []
      }
    },
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === 'volume' && ($(targetClick).is("button") || $(targetClick).is("span") || $(targetClick).is("i"))) {
        return;
      } else if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value.column === 'activeStatus') {
        return;
      }
      if (value.column === 'phoneNumber') {
        return;
      }
      if (value && value.item && value.item.id) {
        this.isFirstLoad = false;
        if (this.actionData.model.listDeviceSelectedCode.includes(value.item.id)) {
          const index = this.actionData.model.listDeviceSelectedCode.indexOf(value.item.id)
          if (index > -1) {
            this.mainTable.options.selectedAll = false;
            this.actionData.model.listDeviceSelectedCode.splice(index, 1);
            value.item._classes = 'inactive';
            this.actionData.model.deviceIgnoreIds.push(value.item.id);
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listDeviceSelectedCode.push(value.item.id);
          const index = this.actionData.model.deviceIgnoreIds.indexOf(value.item.id)
          if (index > -1) {
            this.actionData.model.deviceIgnoreIds.splice(index, 1);
          }

          if (this.actionData.model.checkAll && (!this.actionData.model.deviceIgnoreIds || this.actionData.model.deviceIgnoreIds.length == 0)) {
            this.mainTable.options.selectedAll = true;
          }
        }
      }
    },
    generateIconVolume(volume) {
      if (volume == 0) {
        return 'fa-volume-off'
      } else if (volume < 50) {
        return 'fa-volume-down'
      } else {
        return 'fa-volume-up'
      }
    },
    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status, type) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId || null;
      actionData.deviceSelectedName = deviceName || null;
      actionData.status = status || null;
      actionData.type = type || null;
    },
    changeVolume(id, _volume) {
      let that = this;
      if ((id == '' || id == null) && (that.actionData.model.listDeviceSelectedCode.length == 0)) {
        this.showErrorMsg({ message: 'Chưa có thiết bị nào được chọn' });
        return;
      }

      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id || '',
            volume: _volume,
            deviceIds: []
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.isShowModalChangeVolumeMultipleDevice = false;
            if (that.actionData.model.listDeviceSelectedCode.length == 0) {
              that.showSuccessMsg({
                message: "Thay đổi âm lượng thành công"
              });
            }
            // that.loadDataMainTable(false, false);
            that.loading.value = false;
            $('body').click();
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {

  },
  watch: {
    "actionData.model.selectedAll": function (newValue) {
      let that = this;
      that.$emit("selectedAll", newValue);
      if (newValue) {
        that.$emit("dataSearch", that.$helper.setupDataSubmit(that.$data));
      }
      that.$refs.mainTable.items.map(each => newValue == true ? each._classes = 'active' : each._classes = 'inactive');

    },
    "actionData.model.deviceIgnoreIds": function (newValue) {
      this.$emit("un-selected", newValue)
    },
    "actionData.model.listDeviceSelectedCode": function (newValue) {
      let that = this;
      this.$emit("change-selected", newValue)
      if (!this.isFirstLoad) {
        if (newValue.length > 0) {
          this.$emit("change-valid", false);
        } else {
          this.$emit("change-valid", true);
        }
      } else {
        if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
          // that.actionData.model.selectedAll = true;
          that.$refs.mainTable.items.map(each => each._classes = 'active');
        } else {
          // that.actionData.model.selectedAll = false;
          if (newValue.length == 0) {
            that.$refs.mainTable.items.map(each => each._classes = 'inactive');
          }
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    loadData(value) {
      if (value) {
        this.loadDataMainTable(false, false);
        this.$emit("change-reload", false);
      }
    },
    reset(value) {
      if (value) {
        this.actionData.model.listDeviceSelectedCode = [];
        this.actionData.model.deviceIgnoreIds = [];
        this.actionData.model.checkAll = false;
        this.$emit("clear:selectedAll", false);
      }
    },
  },
  computed: {}
};
</script>
<style scoped>
.speaker {
  font-size: 20px;
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

#baseFormDevice {

  .slider {
    width: 200px;
    max-width: 200px;
    //padding: 0 !important;
  }

  .range-slider-rail,
  .range-slider-fill {
    height: 6px !important;
  }

  .range-slider-fill {
    background-color: #0b98ff;
  }

  .range-slider-knob {
    width: 15px !important;
    height: 15px !important;
  }

  .range-slider {
    padding: unset !important;
  }

  .dropdown-volume {
    padding: unset;
    border-radius: 50px;
  }

  .dropdown-volume a:hover {
    background: none !important;
  }

  .custom-toggle-volume {
    min-width: 70px;
    display: inline-flex !important;
    justify-content: center;
  }

  .custom-toggle-volume i {
    margin-top:0px !important;
  }


  .volume .dropdown {
    display: inline-flex !important;
  }

  .action-custom {
    height: 200px;
    overflow: auto;
  }

  .group-btn-action {
    height: 35px;
  }

  .group-btn-action:hover {
    background: unset !important;
  }

  .device-code-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
    min-width: 0;
  }

  .device-code-line {
    display: inline-flex;
    align-items: center;
    column-gap: 6px;
    white-space: nowrap;
    line-height: 1.15;
  }

  .device-code-value {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
  }

  .device-code-type {
    display: inline-flex;
    align-items: center;
    line-height: 1.1;
    white-space: nowrap;
    margin: 0;
  }


  .microphone {
    position: relative;
    font-size: 100px;
    cursor: pointer;
  }

  .live-microphone {
    position: absolute;
    font-size: 13px;
    border: 1px solid red;
    padding: 3px 5px 3px 5px;
    border-radius: 25px;
    color: white;
    background: red;
    font-weight: bold;
    right: -25px;
    top: -11px;
    -webkit-animation: flickerAnimation 1s infinite;
    -moz-animation: flickerAnimation 1s infinite;
    -o-animation: flickerAnimation 1s infinite;
    animation: flickerAnimation 1s infinite;
  }

  .muted-microphone {
    font-size: 30px;
    cursor: pointer;
  }

  .custom-control-label.input-valid-error::before {
    border-color: red !important;
  }

  #bars {
    position: relative;
    width: 32px;
    height: 20px;
    display: inline-flex;

    .bar {
      position: absolute;
      bottom: 0;
      width: 4px;

      &:nth-child(1) {
        height: 6px;
        left: 0px;
      }

      &:nth-child(2) {
        height: 10px;
        left: 7px;
      }

      &:nth-child(3) {
        height: 14px;
        left: 14px;
      }

      &:nth-child(4) {
        height: 18px;
        left: 21px;
      }
    }
  }

}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
